import { Vue, Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import { sysUrl } from '@/globals'

declare let WebUploader: any;
declare let plupload: any;

@Component({
  name: 'FormImage',
  filters: {
    percentage(value) {
      return Math.floor(value) + '%'
    }
  }
})
export default class FormImage extends Vue {
  @Prop() value: string;

  fileName = ""

  progress: number | null = null

  error: {status: string; content: string;} | null = null

  private _uploader: any;

  updateValue(value) {
    this.$emit('input', value)
  }

  mounted() {
    let btn = this.$el.querySelector('.btnUpload')

    let uploader = new plupload.Uploader({
      browse_button: btn,
      multipart: false,
      multi_selection: false,
      url: sysUrl + '/upd/',
    })
    uploader.init();
    uploader.bind('FilesAdded', (up, files) => {
      uploader.start()
    })
    uploader.bind('UploadProgress', (up, file) => {
      this.fileName = file.name
      this.progress = file.percent
    })
    uploader.bind('FileUploaded', (up, file, result) => {
      let resp = JSON.parse(result.response)
      this.updateValue(resp.url)
      this.progress = null
      this.fileName = ""
    })
    uploader.bind('Error', (up, err) => {
      this.error = {
        status: err.code,
        content: err.message
      }
    })
    this._uploader = uploader
  }

  beforeDestroy() {
    if (this._uploader) {
      try {
        if (this._uploader.destroy)
          this._uploader.destroy()
      }
      catch (e) {
        console.error(e)
      }
    }
  }

  open() {
    if (this.value) {
      window.open(this.value)
    }
  }
}
